import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import Rootpage from "../RootPage";
import { Typography } from "@mui/material";
import * as environmentVariables from "env-config";
import localisations from "shell/localisation";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { HealthCheck } from "./HealthCheck";

const rows = () => {
    const localisation = localisations.pages.environmentConfig.values;

    return Object.keys(localisation)
        .map(key => {
            const titleCaseKey = key[0].toUpperCase() + key.slice(1);
            return {
                name: (localisation as any)[key],
                value: (environmentVariables as any)[titleCaseKey]()
            }
        })
};

function EnvironmentConfigPage() {
    const {
        heading,
        blurb,
        table: { variableKeyHeading, valueHeading },
    } = localisations.pages.environmentConfig;

    return (
        <Rootpage header={heading}>
            <Typography variant="body1" paragraph>
                {blurb}
            </Typography>
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{variableKeyHeading}</TableCell>
                            <TableCell align="right">{valueHeading}</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows().map((row) => (
                            <TableRow key={row.name}>
                                <TableCell component="th" scope="row">
                                    {row.name}
                                </TableCell>
                                <TableCell align="right">
                                    {row.name.endsWith('Api url')
                                        // eslint-disable-next-line react/jsx-no-target-blank
                                        ? <a href={row.value.replace(/\/$/, "")+'/health'} target="_blank" rel="noreferrer">{row.value}</a>
                                        : row.value
                                    }
                                </TableCell>
                                <TableCell>
                                    {row.name.endsWith('Api url') &&
                                        <HealthCheck apiUrl={row.value}/>
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Rootpage>
    );
}

export default withAITracking(reactPlugin, EnvironmentConfigPage, "Environment Config Page");
